<div  class="grid grid-nogutter" *ngIf="previousExperienceSchema && previousExperienceSchema?.previousExperienceDtos?.length; else noWorkExperienceTemplate">
    <div class="col-12">
          <p-table [value]="previousExperienceSchema.previousExperienceDtos"
                   styleClass="p-datatable-striped"
                   [paginator]="true"
                   [rows]="10"
                   [showCurrentPageReport]="true"
                   responsiveLayout="scroll"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                   editMode="row"
                   [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th>EMPLOYMENT TITLE & COMPANY NAME</th>
                    <th>DESCRIPTION</th>
                    <th>EMPLOYMENT PERIOD</th>
                    <th>REASON OF LEAVING</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-previousExperience let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="previousExperience">
                    <td>
                        <p class="text-rb">{{previousExperience.title}}</p>
                        <p>{{previousExperience.companyName}}</p>
                    </td>
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                            </ng-template>
                            <ng-template pTemplate="output">
                                <p class="text-ssb">{{previousExperience.description}}</p>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td >
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                            </ng-template>
                            <ng-template pTemplate="output">
                                <p class="text-ssb" *ngIf="previousExperience.from">{{previousExperience.from | date: 'shortDate'}} - {{previousExperience.to | date: 'shortDate'}}</p>
                                <p class="text-ssb" *ngIf="previousExperience.startDate">{{previousExperience.startDate | date: 'shortDate'}} - {{previousExperience.endDate | date: 'shortDate'}}</p>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                            </ng-template>
                            <ng-template pTemplate="output">
                                <p class="text-ssb">{{ getReason(previousExperience.leavingReason).title}}</p>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<ng-template #noWorkExperienceTemplate>
    <div  class="grid grid-nogutter">
        <div class="col-12 flex justify-content-center align-items-center">
            <div class="w-40 flex justify-content-center">
                <p-button  *ngIf="showAddButton"
                           (click)="onClick.emit()"
                           class="primary" label="Work Experience"
                           icon="pi pi-plus"  [disabled]="!enabledButton"></p-button>
            </div>
        </div>
    </div>
</ng-template>
